// src/components/BattleMetaInfo.jsx
import React from 'react';

export default function BattleMetaInfo({
  raidName = '',
  timestamp = '',
  battleTime = '',
  isCompare = false,
  isAverage = false,
}) {
  const fmt = v => (v && String(v).trim()) || '';
  const hideTimestamp = isCompare || isAverage;

  const parseBadge = (value) => {
    const str = String(value ?? '').trim();
    const m = str.match(/\((↑|↓)\s*([^)]+)\)\s*$/);
    if (!m) return { base: str, badge: null, dir: null };

    const num = parseFloat(m[2].replace(/[^0-9.-]/g, ''));
    if (isNaN(num) || num === 0) {
      return { base: str.replace(/\s*\((↑|↓)[^)]+\)\s*$/, '').trim(), badge: null, dir: null };
    }
    const dir = m[1] === '↑' ? 'up' : 'down';
    const base = str.replace(/\s*\((↑|↓)[^)]+\)\s*$/, '').trim();
    const badge = `${m[1]}${m[2]}`.replace(/\s+/g, '');
    return { base, badge, dir };
  };

  const badgeClass = (dir) =>
    dir === 'up'
      ? 'inline-flex items-center gap-x-1.5 rounded-md px-1.5 py-0.5 text-xs font-medium bg-red-500/15 text-red-700 dark:bg-red-400/10 dark:text-red-400'
      : 'inline-flex items-center gap-x-1.5 rounded-md px-1.5 py-0.5 text-xs font-medium bg-emerald-500/15 text-emerald-700 dark:bg-emerald-400/10 dark:text-emerald-300';

  const { base: timeBase, badge: timeBadge, dir: timeDir } = parseBadge(battleTime);

  return (
    <section
      className="
        flex flex-col lg:flex-row basis-1/2 gap-2 lg:gap-6 rounded-lg border border-zinc-950/10 bg-white px-4 py-3 shadow-sm dark:border-white/10 dark:bg-zinc-900 dark:shadow-none
      "
    >
      <div className="flex flex-col">
        <span className="text-sm text-zinc-500 dark:text-zinc-400">레이드명</span>
        <span className="font-medium text-zinc-950 dark:text-zinc-50 tracking-tighter">{fmt(raidName)}</span>
      </div>

      {!hideTimestamp && (
        <div className="flex flex-col">
          <span className="text-sm text-zinc-500 dark:text-zinc-400">돌린시각</span>
          <span className="font-medium text-zinc-950 dark:text-zinc-50 tracking-tighter">{fmt(timestamp)}</span>
        </div>
      )}

      <div className="flex flex-col">
        <span className="text-sm text-zinc-500 dark:text-zinc-400">전투시간</span>
        <span className="font-medium text-zinc-950 dark:text-zinc-50 tracking-tighter">
          {fmt(timeBase)}
          {timeBadge && <span className={`ml-2 ${badgeClass(timeDir)}`}>{timeBadge}</span>}
        </span>
      </div>
    </section>
  );
}
